import { Box, Container, useMediaQuery, useTheme } from '@mui/material';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import { SettingsSidebar } from './components/SettingsSidebar';
import { MobileNavigation } from './components/MobileNavigation';

export const SettingsPage = () => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Default to profile if at /settings root
  if (location.pathname === '/settings') {
    return <Navigate to="/settings/profile" replace />;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        minHeight: 0,
        bgcolor: 'background.default'
      }}
    >
      {/* Desktop Sidebar */}
      {!isMobile && <SettingsSidebar />}

      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto'
        }}
      >
        {/* Settings Content */}
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            p: isSmallMobile ? 2 : 4,
            pb: isSmallMobile ? 10 : 4 // Extra bottom padding for mobile FAB
          }}
        >
          <Container
            maxWidth="lg"
            sx={{
              flex: 1,
              minHeight: 0,
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Outlet />
          </Container>
        </Box>
      </Box>

      {/* Mobile Navigation */}
      {isSmallMobile && <MobileNavigation />}
    </Box>
  );
};
